/**
 * Shared list params for notes queries (newest first).
 */
export function notesListParams(organizationId: string): {
	OrganizationId: string;
	OrderBy: { Fields: string[]; Descending: boolean };
} {
	return {
		OrganizationId: organizationId,
		OrderBy: { Fields: ["CreatedAt"], Descending: true },
	};
}
